import {Link} from "react-router-dom";
import React from "react";
import {Button, Select, Tag} from "antd";
import {orderProcessingTimeColor, PaymentTypeIcon} from "../../utils/orderUtils";

const OrdersColumns = (t, hideNumber, marketOptions, filters) => {
    const columns = [
        !hideNumber ? {
            title: t('pages.orders.listColumns.column7'),
            dataIndex: 'number',
            orderIndex: "number",
        } : {
            title: t('pages.orders.listColumns.column8'),
            dataIndex: 'key',
            orderIndex: "number",
        },
        {
            title: 'Type',
            dataIndex: 'type',
            orderIndex: "number",
        },
        {
            title: t('pages.orders.listColumns.column6'),
            dataIndex: 'payment_type',
            filters: [
                {text: 'cash', value: 'cash'},
                {text: 'card', value: 'card'},
                {text: 'uncork', value: 'uncork'},
            ],
            filterMultiple: false,
            filteredValue: filters.payment_type ? [filters.payment_type] : null,
            // onFilter: (value, record) => record.payment_type === value,
            render: (_, record) => (
                <>
                    <PaymentTypeIcon type={record.payment_type} t={t}/>
                </>
            )
        },
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('pages.orders.listColumns.column1')}
                </span>
            ),
            dataIndex: 'market_name',
            key: 'market_name',
            filteredValue: filters.market__id ? [filters.market__id] : null,  // use ID
            filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                <div style={{padding: 8}}>
                    <Select
                        virtual={false}
                        style={{width: 250}}
                        value={selectedKeys[0] || undefined}
                        options={marketOptions}       // grouped by district
                        placeholder="Select Market"
                        onChange={value => setSelectedKeys(value ? [value] : [])}
                        allowClear
                        showSearch
                        optionFilterProp="label"      // search by name
                    />
                    <div style={{marginTop: 8, display: 'flex', gap: 8}}>
                        <Button type="primary" onClick={() => confirm()} size="small">OK</Button>
                        <Button onClick={() => {
                            clearFilters();
                            confirm();
                        }} size="small">Reset</Button>
                    </div>
                </div>
            ),
            onFilter: () => true,  // always true for server-side filtering
            filterSearch: true,
            render: (text, record) => <Link to={`/order/detail/${record.key}`}>{text}</Link>,
        },
        {
            title: (
                <span style={{textDecoration: 'underline'}}>
                    {t('pages.orders.listColumns.column2')}
                </span>
            ),
            dataIndex: 'cash_desc_serial',
            render: (text, record) => (
                <Link to={`/order/detail/${record.key}`}>{text}</Link>
            ),
            sorter: false,
            orderIndex: "cash_desc_serial",
        },
        {
            title: t('pages.orders.listColumns.column3'),
            dataIndex: 'cashier',
            sorter: true,
            orderIndex: "cashier",
        },
        {
            title: t('pages.orders.listColumns.column4'),
            dataIndex: 'orderPrice',
            sorter: true,
            orderIndex: "annotated_order_price",
            render: (text, record) => (
                <>
                    {[record.orderPrice].map(tag => (
                        <Tag
                            color={record.payment_type === "cash" ? 'green' : 'blue'}
                            key={tag}
                        >
                            {`${String(tag)}`.toUpperCase()}
                        </Tag>
                    ))}
                </>
            ),
        },
        {
            title: t('pages.orders.listColumns.column9'),
            dataIndex: 'order_processing_time',
            sorter: false,
            orderIndex: null,
            render: (text, record) => (
                <>
                    {[record.order_processing_time].map(tag => (
                        <Tag
                            color={orderProcessingTimeColor(tag)}
                            key={tag}
                        >
                            {tag} {t('common.seconds')}
                        </Tag>
                    ))}
                </>
            ),
        },
        {
            title: t('pages.orders.listColumns.column5'),
            dataIndex: 'created_date',
            sorter: true,
            orderIndex: "created_date",
        },
    ]

    return columns.filter(column => column !== null);
};

export default OrdersColumns;
